export default "/images/dribbble.svg?491ed4db870160e53489f3d1af4312e4";